// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__YsvNP","addWidgetButton":"Header_addWidgetButton__1SBAH","dashboardTabs":"Header_dashboardTabs__3m6RU","active":"Header_active__J9Pi9"};